import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { CallBackTransformService } from './call-back-transform.service';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root'
})
export class AssessmentService {

  constructor(
    private http: HttpClient,
    private callBackService: CallBackTransformService,
    public envService: EnvService
  ) { }

  saveAssessmentProgress(params): Observable<any> {
    const url = this.envService.apiUrl + 'assessment';
    return this.http.post<any>(url, params).pipe(
      map(output => {
        return this.callBackService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }
  saveEditedAssessmentProgress(params): Observable<any> {
    const url = this.envService.apiUrl + 'update-assessment';
    return this.http.put<any>(url, params).pipe(
      map(output => {
        return this.callBackService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /* GetAllVoiceType. */
  getAllVoiceType(personIndex): Observable<any> {
    const url = this.envService.apiUrl + 'active-voice-type/' + personIndex;
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  SendAssessmentEmail(assessmentEmailData): Observable<any> {
    const url = this.envService.apiUrl + 'email-assessment';
    return this.http.post<any>(url, assessmentEmailData).pipe(
      map(output => {
        return this.callBackService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /* AllResponseBehaviors. */
  getAllResponseBehaviors(): Observable<any> {
    const url = this.envService.apiUrl + 'item-Response-Behavior/';
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  ResendAssessmentEmail(assessmentEmailData): Observable<any> {
    const url = this.envService.apiUrl + 'resend-email-assessment';
    return this.http.post<any>(url, assessmentEmailData).pipe(
      map(output => {
        return this.callBackService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /* Get assessment configurations. */
  getAssessmentConfigurations(): Observable<any> {
    const url = this.envService.apiUrl + 'assessment-configurations' ;
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  processRuleEngine(params): Observable<any> {
    const url = this.envService.apiUrl + 'process-rules-engine';
    return this.http.post<any>(url, params).pipe(
      map(output => {
        return this.callBackService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  getAllTemplates(): Observable<any> {
    const url = this.envService.apiUrl + 'external-message-template';
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  getBase64StringFromURL(param): Observable<any> {
    // Encode URL
    const encodedFileUrl = encodeURIComponent(param);
    const url = this.envService.apiUrl + 'downloadBlobFiles?fileUrl=' + encodedFileUrl;
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
    

  }
}
